import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoCircle16 = t0 => {
  const $ = _c(9);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  if ($[2] !== iconColor) {
    t2 = <g><path d="M8.00098 3C10.7624 3 13.001 5.23858 13.001 8C13.001 10.7614 10.7624 13 8.00098 13C5.23955 13 3.00098 10.7614 3.00098 8C3.00098 5.23858 5.23955 3 8.00098 3ZM8.00098 4.25C5.92991 4.25 4.25098 5.92893 4.25098 8C4.25098 10.0711 5.92991 11.75 8.00098 11.75C10.0721 11.75 11.751 10.0711 11.751 8C11.751 5.92893 10.0721 4.25 8.00098 4.25Z" fill={iconColor} /></g>;
    $[2] = iconColor;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <defs />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2) {
    t4 = <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default IcoCircle16;